import { schema } from 'normalizr';

import { ActionTypes } from './Home.actions';

const application = new schema.Entity('applications');


export const namespaces = {
    archive: 'archive',
    preview: 'preview'
};

export const getNamespace = (archived) => (archived ? namespaces.archive : namespaces.preview);



const actionsSchemas = {
    [ActionTypes.fetchApplicationsCompleted]: [application]
};
export default actionsSchemas;
